import {NpmModuleApiController} from './NpmModuleApiController';
import {Poly, PolyEngine} from '../../@polygonjs/polygonjs/src/engine/Poly';
import {FilesRegister} from '../editor/self_contained/FilesRegister';
import {PolyScene} from '../../@polygonjs/polygonjs/src/engine/scene/PolyScene';
type ResolveCallback = (value: unknown) => void;
type ConfigureSceneCallback = (scene: PolyScene) => void;
declare global {
	interface Window {
		__POLYGONJS_POLY__: PolyEngine | undefined;
		__POLYGONJS_POLY_CONFIG_CONFIGURE_SCENE: ConfigureSceneCallback | undefined;
		__POLYGONJS_POLY_CONFIG_INSTANCE__RESOLVE: ResolveCallback | undefined;
	}
}
export class NpmModulePolyConfigLoadController {
	// private static _resolve: ((t: unknown) => void) | undefined;
	static load(sceneName:string): Promise<void> {
		return new Promise(async (resolve) => {
			// this._resolve = resolve;
			// ensure window.__POLYGONJS_POLY_INSTANCE__ is declared
			window.__POLYGONJS_POLY__ = Poly;

			// the scene is unlikely to exit when requesting the polyConfig
			// const scene = StoreController.scene;
			// const sceneName = scene.name();
			// if (!sceneName) {
			// 	return;
			// }

			// we register the raw config first,
			// as otherwise this may lead to 2 compilations happening at the same time on the server app.
			await FilesRegister.registerPolyConfig(NpmModuleApiController.config.polyConfigUrlRaw({sceneName}));

			const url = NpmModuleApiController.config.polyConfigUrl({sceneName});
			window.__POLYGONJS_POLY_CONFIG_INSTANCE__RESOLVE = () => {
				resolve();
			};
			const scriptElement = document.createElement('script');
			scriptElement.setAttribute('type', 'module');
			const text = `
			import {configurePolygonjs, configureScene} from '${url}';
			if(window.__POLYGONJS_POLY__ && window.__POLYGONJS_POLY__.wrapConfigurePolygonjs) {
				window.__POLYGONJS_POLY__.wrapConfigurePolygonjs(async ()=>{
					await configurePolygonjs(window.__POLYGONJS_POLY__)
				});
			}else{
				console.warn('configurePolygonjs not run')
			}
			window.__POLYGONJS_POLY_CONFIG_CONFIGURE_SCENE = configureScene;
			const polyConfigResolve = window.__POLYGONJS_POLY_CONFIG_INSTANCE__RESOLVE;
			window.__POLYGONJS_POLY_CONFIG_INSTANCE__RESOLVE = undefined;
			window.__POLYGONJS_POLY__ = undefined;
			if(polyConfigResolve) {
				polyConfigResolve()
			} else {
				console.warn('polyConfigResolve not run')
			}
			`;
			scriptElement.text = text;
			document.body.appendChild(scriptElement);

			// scriptElement.onload = ()=>{
			// 	resolve()
			// };

			// const url = NpmModuleApiController.load_poly_config_url();
			// const script_element = document.createElement('script');
			// script_element.src = url;
			// document.body.appendChild(script_element);

			// this.check_if_config_loaded();
		});
	}

	// static check_if_config_loaded() {
	// 	if (window.__POLYGONJS_POLY_INSTANCE__CONFIG_LOADED) {
	// 		if (this._resolve) {
	// 			this._resolve(undefined);
	// 		}
	// 	} else {
	// 		setTimeout(() => {
	// 			this.check_if_config_loaded();
	// 		}, 100);
	// 	}
	// }
}
